
class PureGameElement {
    constructor ( scene){
        this.scene = scene;
        this.game = window.game;
    }

    create(){}
    preload(){}
    update(){}

}
export default PureGameElement;
